// extracted by mini-css-extract-plugin
module.exports = {"itemSkeleton":"_93d7f26","headerSkeleton":"_e31d76a"};